import { StreamChatUserData } from "@/core/context/StreamChatContext"
import ChatChannelCustomAttachment from "@components/chat/channel/attachment/ChatChannelCustomAttachment"
import ChatChannelAvatar from "@components/chat/channel/detail/avatar/ChatChannelAvatar"
import clsx from "clsx"
import { TranslationLanguages } from "stream-chat"
import {
  DefaultStreamChatGenerics,
  useChannelActionContext,
  useMessageContext,
  useTranslationContext,
} from "stream-chat-react"

export const QuotedMessage = <
  StreamChatGenerics extends DefaultStreamChatGenerics = DefaultStreamChatGenerics
>() => {
  const { isMyMessage, message } = useMessageContext<StreamChatGenerics>("QuotedMessage")
  const { userLanguage } = useTranslationContext("QuotedMessage")
  const { jumpToMessage } = useChannelActionContext("QuotedMessage")

  const { quoted_message } = message
  if (!quoted_message) return null

  const quotedMessageText =
    quoted_message.i18n?.[`${userLanguage}_text` as `${TranslationLanguages}_text`] ||
    quoted_message.text

  // @ts-expect-error
  const quotedMessageAttachment = quoted_message.attachments.length
    ? // @ts-expect-error
      quoted_message.attachments[0]
    : null

  if (!quotedMessageText && !quotedMessageAttachment) return null

  return (
    <>
      <div
        className={clsx("str-chat__quoted-message-preview quoted-message", {
          mine: isMyMessage(),
        })}
        onClickCapture={(e) => {
          e.stopPropagation()
          e.preventDefault()
          jumpToMessage(quoted_message.id)
        }}
      >
        {quoted_message.user && (
          <ChatChannelAvatar user={quoted_message.user as StreamChatUserData} />
        )}
        <div className={"quoted-message-inner str-chat__quoted-message-bubble"}>
          {quotedMessageAttachment && (
            <ChatChannelCustomAttachment attachments={[quotedMessageAttachment]} />
          )}
          <div>{quotedMessageText}</div>
        </div>
      </div>
      {message.attachments?.length && message.quoted_message ? (
        <ChatChannelCustomAttachment attachments={message.attachments} />
      ) : null}
    </>
  )
}
